<!-- Menu « Autres actions » de la fiche (#1083), ouvert depuis l'en-tête de page. -->
<ng-template #menu>
  <div class="menu-actions" cdkMenu>
    @if (!amac?.membreId) {
      <button type="button" class="menu-actions__item" cdkMenuItem (cdkMenuItemTriggered)="saisieMembre()">Créer un membre</button>
    }
    <button type="button" class="menu-actions__item" cdkMenuItem (cdkMenuItemTriggered)="saisieActivite()">Créer une activité</button>
  </div>
</ng-template>

<!-- Volets des sous-formulaires ; le volet F_MENU a disparu au profit du menu ci-dessus (#1083). -->
<app-popup-bar>
  <!--
  <app-popup-bar-flap [key]="F_MENU">
    @if (!amac?.membreId) {
      <button class="btn btn-secondary m-2 w-100" (click)="saisieMembre()">Créer un membre</button>
    }
    <button class="btn btn-secondary m-2 w-100" (click)="saisieActivite()">Créer une activité</button>
  </app-popup-bar-flap>
  -->
  <app-popup-bar-flap [key]="F_NOUVELLE_ACTIVITE">
    <app-saisie-activite (newActiviteId)="onCreateActivite($event)"></app-saisie-activite>
  </app-popup-bar-flap>
  <app-popup-bar-flap [key]="F_NOUVEAU_MEMBRE">
    <app-saisie-membre (newMembreId)="onCreateMembre($event)"></app-saisie-membre>
  </app-popup-bar-flap>
</app-popup-bar>
